const styleOverrides = {
  root: {
    cursor: 'pointer',

    svg: {
      fontSize: 'inherit',
      marginBottom: -2,
      '&:first-of-type:not(:last-child)': {
        marginRight: '7px',
      },
      '&:last-child': {
        marginLeft: '7px',
      },
    },
  },
  underlineHover: {
    borderBottom: '1px solid transparent',
    '&:hover': {
      textDecoration: 'none',
      borderBottom: '1px solid',
    },
  },
  underlineAlways: {
    textDecoration: 'none',
    borderBottom: '1px solid',

    '&:hover': {
      textDecoration: 'none',
      borderBottom: '1px solid',
    },
  },
};

export default styleOverrides;
